import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { convertPriceToSelectedCurrency } from "../../helpers/currencyHelpers";

class PriceDisplay extends React.Component {
  convert = () => {
    const {
      price,
      selectedCurrencyCode,
      currentCurrencyCode,
      fallBackCurrencySymbol,
      currencies,
      taxesPrecentage,
      displayPriceWithoutTaxes,
      showPricePerNightThumb,
      checkinDate,
      checkoutDate
    } = this.props;

    const normalizedPrice = convertPriceToSelectedCurrency(
      price,
      selectedCurrencyCode,
      currentCurrencyCode,
      fallBackCurrencySymbol,
      currencies,
      taxesPrecentage,
      displayPriceWithoutTaxes,
      showPricePerNightThumb,
      checkinDate,
      checkoutDate
    );
    return normalizedPrice;
  };
  render() {
    const { children } = this.props;
    const convertedPrice = this.convert();
    return children(convertedPrice);
  }
}

PriceDisplay.propTypes = {
  currencies: PropTypes.array,
  price: PropTypes.number,
  selectedCurrencyCode: PropTypes.string,
  currentCurrencyCode: PropTypes.string,
  fallBackCurrencySymbol: PropTypes.string,
  children: PropTypes.func,
  displayPriceWithoutTaxes: PropTypes.bool,
  taxesPrecentage: PropTypes.number,
  showPricePerNightThumb: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string
};

PriceDisplay.defaultProps = {
  showPricePerNightThumb: false
};

const mapStateToProps = store => {
  return {
    selectedCurrencyCode: store.selectedCurrency,
    currencies: store.currencies,
    displayPriceWithoutTaxes: store.displayPriceWithoutTaxes,
    taxesPrecentage: store.taxesPrecentage,
    // showPricePerNightThumb: store.showPricePerNightThumb,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate
  };
};

export default connect(mapStateToProps)(PriceDisplay);

{
  /* <PriceDisplay>
{convertedPrice => <div>{convertedPrice}</div>}
</PriceDisplay> */
}



// WEBPACK FOOTER //
// ./src/containers/PriceDisplay/PriceDisplay.js